import { apiClient } from '@littlebird/auth-client';
import { useMutation } from '@tanstack/react-query';

export const VoteDataDirection = {
  DOWN: -1,
  UP: 1,
} as const;

export type EntityType =
  | 'action_card'
  | 'meeting'
  | 'meeting_assist'
  | 'meeting_prep'
  | 'routine_report';

export type VoteDataDirectionType =
  (typeof VoteDataDirection)[keyof typeof VoteDataDirection];

export function useVote({ chat_id }: { chat_id: string | null }) {
  return useMutation({
    mutationFn: async ({
      id,
      direction,
      reasoning,
      include_chat_history,
    }: {
      id: string;
      direction: VoteDataDirectionType;
      reasoning: string | null;
      include_chat_history: boolean;
    }) => {
      if (chat_id === null) throw new Error('Chat ID is required');

      await apiClient.post('vote', {
        chat_id,
        message_id: id,
        direction,
        reasoning,
        include_chat_history,
      });
    },
  });
}

export function useVoteEntity() {
  return useMutation({
    mutationFn: async ({
      entity_type,
      entity_id,
      direction,
      reasoning,
    }: {
      entity_type: EntityType;
      entity_id: string;
      direction: VoteDataDirectionType;
      reasoning: string | null;
    }) => {
      await apiClient.post('vote_entity', {
        entity_type,
        entity_id,
        direction,
        reasoning,
      });
    },
  });
}
